import { TsuLoading } from '@/common/components';
import { AppLayout } from '@/layouts/AppLayout';
import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { IPunchoutWaivenet, IPunchoutWaivenetVars } from '../../PunchoutInterface';

const WAIVENET_PUNCHOUT_PMS_MUTATION = gql`
  mutation ($destination: String!, $returnURL: String!) {
    punchoutWaivenetPms(input: { destination: $destination, returnURL: $returnURL }) {
      success
      link
    }
  }
`;

export function ProjectManagement() {
  const [punchoutWaivenetPmsMutation, { data, loading }] = useMutation<
    IPunchoutWaivenet,
    IPunchoutWaivenetVars
  >(WAIVENET_PUNCHOUT_PMS_MUTATION, {
    variables: { destination: 'projectManagement', returnURL: 'https://test.com.au' },
  });

  useEffect(() => {
    punchoutWaivenetPmsMutation();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      console.log('[ProjectManagement] Got MessageEvent:', event);
      console.log('got here?');
      if (event.origin === 'https://staging.waivenet.com.au') {
        try {
          console.log('[ProjectManagement] Event data:', event.data);
        } catch (err) {
          console.error(`[ProjectManagement] Error parsing message: ${event.data.toString()}`);
        }
      }
    };
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <AppLayout title="Project Management">
      <TsuLoading loading={loading}>
        <iframe
          id="punchout"
          // @ts-ignore
          src={data?.punchoutWaivenetPms.link}
          style={{ width: '100%' }}
          height={1080}
        ></iframe>
      </TsuLoading>
    </AppLayout>
  );
}